import React, { FunctionComponent } from 'react'
import { SelectProps } from '@mui/material/Select'
import { StyledSelect } from './Select.styles'

const Select: FunctionComponent<SelectProps> = React.memo((props) => {
  return <StyledSelect {...props} />
})


export default Select